<template>
	<div class="subscription-column-totals">
		<template v-if="carttype == 'shopping-cart'">
			<div class="total-row">
				<h6>{{ __("Total Setup and Purchase") }}<sup class="total-note-marker">*</sup></h6>
				<h6>{{ ioi_format_currency(subscription_object.setup_total_in_basket || 0.0, subscription_object.currency) }}</h6>
			</div>
			<div class="total-row">
				<h6>{{ __("Total Subscription") }}<sup class="total-note-marker">*</sup></h6>
				<h6>{{ ioi_format_currency(subscription_object.subscription_total_in_basket || 0.0, subscription_object.currency) }}</h6>
			</div>
			<div class="total-row">
				<h6>{{ __("Setup time") }}<sup class="total-note-marker">**</sup></h6>
				<h6>{{ subscription_object.setup_time_in_basket }} {{ __("Hours") }}</h6>
			</div>
			<p class="subscription-column-vat-note">{{ __("Prices exclude VAT") }}<sup class="total-note-marker">*</sup></p>
			<!-- The basket's sum says it holds a variable price, as the floating cart does
			     (FloatingCart.vue): the note opens the rules of those of its products that
			     have one (PriceRuleTrigger.vue), and is plain text when none has. -->
			<p v-if="variable_basket_lines.length" class="subscription-column-vat-note">
				<price-rule-trigger :rules="variable_basket_rules" :text="__('contains variable price, see rules')" />
			</p>
		</template>
		<setup-time-footnote :subscription_items="subscription_object.subscription_items" />
		<!-- Read-only, and part of the summary rather than of the consent form below:
		     it sits under the setup-time footnote, above the separator that opens
		     CartValidation. The navbar badge is where the reseller gets changed (later:
		     its own page), so there is no control of any kind here.
		     reseller_display_name is resolved server-side through that badge's own
		     resolver (www/subscription.py), placeholder included. It is absent from a
		     guest's locally built cart, and empty only when the placeholder record itself
		     is missing; either way the label would stand alone, so the line goes instead. -->
		<p v-if="carttype == 'shopping-cart' && subscription_object.reseller_display_name" class="cart-total-reseller">
			{{ __("My selected reseller") }}: {{ subscription_object.reseller_display_name }}
		</p>
	</div>
</template>

<script setup>
import { ioi_format_currency } from "./format_currency";
import SetupTimeFootnote from "./SetupTimeFootnote.vue";
import PriceRuleTrigger from "./PriceRuleTrigger.vue";
import { computed } from "vue";


const props = defineProps({
	subscription_object: {
		type: Object,
		default: () => { return {} }
	},
	carttype: {
		type: String,
		default: "subscription"
	}
})

// The basket's lines with a variable price, as the floating cart finds them
// (FloatingCart.vue): the lines with a quantity in the basket, a logged-in line's stored
// variable_price, a guest line's from the catalogue (guest_cart.js to_line).
const variable_basket_lines = computed(() => (props.subscription_object.subscription_items || [])
	.filter(item => item.qty_in_basket > 0 && item.variable_price))
// The bubble lists those whose product has a rule, by name, as the floating cart's does:
// each product once, whatever its lines.
const variable_basket_rules = computed(() => variable_basket_lines.value
	.filter(item => item.price_rule)
	.filter((item, index, items) => items.findIndex(other => other.product_id === item.product_id) === index)
	.map(item => ({ name: item.product_name || item.product_id, html: item.price_rule, lang: item.price_rule_lang })))

</script>